const styles = theme => ({
    footerLi: {
        listStyle: 'none',
        fontSize: 14,
        fontWeight: 600,
        color: theme.palette.text.primary,
        paddingRight: 5,
    },
    anchor: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2),
        textDecoration: 'none',
        paddingBottom: 1,
        borderBottom: `solid 1px ${theme.palette.text.secondary}`
    },
});

export default styles;